module.exports = __webpack_public_path__ + "img/weather.e83f1f00.jpg";